// extracted by mini-css-extract-plugin
export default {"control":"Product_control__liX4B","richText":"Product_richText__rgz5C"};